import marked from 'marked'

var sb = require('@sb/util')

export default {
	name: 'TextMessage',
	props: ['ev'],

	render () {
		var format = sb.get(this.ev, 'data.message.format', 'plaintext')
		if (format === 'markdown') return this.renderMarkdown()

		var text = sb.get(this.ev, 'data.message.text')
		if (sb.size(text) === 0) return null

		let byType = sb.get(this.ev, 'by.type')

		var tags = sb.extractText(text).map(tag => {
			if (tag.type === 'emoji') return <Emoji emojiCode={tag.text} byType={byType} />
			if (tag.type === 'link') {
				return (
					<a href={tag.text} target="_blank">
						{tag.text}
					</a>
				)
			}
			if (tag.type === 'phone') return <a href={'tel:' + tag.text}>{tag.text}</a>
			if (tag.type === 'email') return <a href={'mailto:' + tag.text}>{tag.text}</a>
			return tag.text
		})

		if (byType === 'agent') {
			return <div class="message-agent message-text--agent">{tags}</div>
		}
		return <div class="message-user message-text--user">{tags}</div>
	},

	methods: {
		renderMarkdown () {
			var text = sb.get(this.ev, 'data.message.text')
			if (sb.size(text) === 0) return null

			let byType = sb.get(this.ev, 'by.type')

			if (byType === 'agent') {
				return (
					<div class="markdown-message message-agent message-text--agent">
						<div domPropsInnerHTML={marked(text)}></div>
					</div>
				)
			}

			return (
				<div class="d-flex flex-column align-items-end">
					<div class="markdown-message message-user message-text--user">
						<div domPropsInnerHTML={marked(text)}></div>
					</div>
				</div>
			)
		},
	},
}
